<!--
 * Created by JackCui on 2021/12/2
 -->
<script>
  export default {
    name: 'group-render',
    inject: ['formData'],
    props: {
      node: Object
    },
    computed: {
      newProps () {
        const {props, propsFn} = this.node
        let _props = Object.assign({}, props)

        if (typeof propsFn === 'function') {
          return Object.assign(
            _props,
            propsFn.call(this, {
              field: this.node,
              formData: this.formData
            })
          )
        }

        return _props
      }
    },
    methods: {
      slotsHandle (position) {
        const {slots} = this.node
        const slotsFn = slots?.[position]
        if (slotsFn) {
          return slotsFn(this.$createElement, { node: this.node, formData: this.formData }) || true
        }

        return null
      },
      createdHeader (field) {
        if (field) {
          return <field-render class='summary-header' node={field} forceFollow={true}></field-render>
        }
        return this.slotsHandle('header')
      }
    },
    render (h) {
      const {
        viewContent = [],
        headerField
      } = this.node
      const {hide} = this.newProps
      if (hide) {
        return null
      }
      return (
        this.slotsHandle('default') ||
        <group
          {...{props: this.newProps}}
          scopedSlots={{
            header: this.createdHeader(headerField),
            afterTitle: this.slotsHandle('header_after'),
            headerOperate: this.slotsHandle('header_operate')
          }}
        >
          {this.slotsHandle('content_before')}
          {
            this.slotsHandle('content') || (viewContent.map(node => {
              /* eslint-disable */
              const Component = node.viewComponentName
              return <Component node={node} key={node.apiName} {...{props: node.props}} />
            }))
          }
         {this.slotsHandle('content_after')}
        </group>
      )
    }
  }
</script>
<style scoped lang='scss'>
.summary-header{
  padding: 0;
  ::v-deep {
    .field{
      padding: 0;
    }
    .follow-box {
      .follow-label,.field.is-pure-text {
        color: #242F57;
        font-weight: 500;
        font-size: 18px;
        max-width: none;
      }
      .follow-conent {
        display: inline-block
      }
    }
  }
}
</style>
